export function renderSelectOptionsTableGeneratedValueTemplate({
  variableName,
  tableName,
  indexName
}: {
  variableName: string
  tableName: string
  indexName: string
}): string {
  return `export const ${variableName} = pgTable(
  '${tableName}',
  {
    id: uuid().defaultRandom().primaryKey().notNull(),
    fieldName: varchar('fieldName', { length: 100 }).notNull(),
    label: varchar('label', { length: 255 }).notNull(),
    value: varchar('value', { length: 255 }).notNull(),
    createdAt: timestamp('createdAt', { precision: 3, mode: 'string' })
      .default(sql\`CURRENT_TIMESTAMP\`)
      .notNull(),
    updatedAt: timestamp('updatedAt', { precision: 3, mode: 'string' })
      .default(sql\`CURRENT_TIMESTAMP\`)
      .notNull(),
    createdBy: text('createdBy').references(() => user.id, { onDelete: 'set null' }),
    updatedBy: text('updatedBy').references(() => user.id, { onDelete: 'set null' })
  },
  (table) => [
    uniqueIndex('${indexName}').using(
      'btree',
      table.fieldName.asc().nullsLast().op('text_ops'),
      table.value.asc().nullsLast().op('text_ops')
    )
  ]
)
`
}
